import { Button, Grid, Link, Typography } from '@mui/material'

import appDownloadQr from '../../images/app-download-qr.svg'
import protectLogo from '../../images/protect-icon-logo-2.svg'
import useIsMobile from '../../utils/hooks/useIsMobile'
import FullScreenModal from '../full-screen-modal'

import classes from './index.styles'

interface IActivateWithAppDialogProps {
  open: boolean
  onClose: () => void
}

const APP_DOWNLOAD_URL = 'https://meshifyprotect.app.link/app'
const MORE_INFO_URL = 'https://resources.meshify.com'

const ActivateWithAppDialog = ({ open, onClose }: IActivateWithAppDialogProps) => {
  const isMobile = useIsMobile()

  return (
    <FullScreenModal title="Activate with Protect App" open={open} onClose={onClose} showCloseIcon={true}>
      <Grid container={true} sx={classes.contentContainer(isMobile)}>
        <Typography variant="body1" sx={classes.descriptionText}>
          {!isMobile
            ? 'To proceed, scan the QR code below and download our app. The app is required to activate devices.'
            : 'To proceed, download our app. The app is required to activate devices.'}{' '}
          <Link href={MORE_INFO_URL} target="_blank" rel="noopener noreferrer" sx={classes.moreInfoLink}>
            More info
          </Link>
        </Typography>

        {!isMobile ? (
          <Grid container={true} sx={classes.logosContainer}>
            <img src={protectLogo} alt="Meshify Protect Logo" width={91} height={93} />
            <img src={appDownloadQr} alt="QR Code to download app" width={96} height={96} />
          </Grid>
        ) : (
          <Button variant="contained" size="large" disableElevation={true} href={APP_DOWNLOAD_URL} component="a">
            Download App
          </Button>
        )}

        <Typography variant="body1" color="text.secondary">
          Once activated, you can use either the mobile app or the web portal to manage accounts, monitor devices, and more.
        </Typography>
      </Grid>
    </FullScreenModal>
  )
}

export default ActivateWithAppDialog
